import { ioclFuelImport } from "_services";
import { ButtonExcelForQuick, CommonInput, ExcelDownload, Heading } from "components";
import { utils } from "helper";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import StorageService from "utils/StorageServices";
import * as Yup from "yup";

const IOCLFuelUpload = () => {

    const initi = {
        company_id: StorageService.getCompanyId(),
        file: null,
    };

    const navigate = useNavigate();

    const [form, setForm] = useState(initi);
    const [formError, setFormError] = useState("");
    const [loading, setLoading] = useState(false);
    const [statusCounts, setStatusCounts] = useState({
        total: 0,
        success: 0,
        skipped_vehicle: 0,
        skipped_duplicate: 0,
    });
    const [skippedVehicleList, setSkippedVehicleList] = useState([]);
    const [skippedDuplicateTxn, setSkippedDuplicateTxn] = useState([]);
    const [successVehicleList, setSuccessVehicleList] = useState([]);
    const [activeTab, setActiveTab] = useState("skipped_vehicle"); // "success" | "skipped_vehicle" | "skipped_duplicate"
    const [showStatus, setShowStatus] = useState(false);

    const fileSchema = {
        uploadFileSchema: Yup.object().shape({
            file: Yup.mixed().required("File is required"),
        }),
    };

    const handleOnChange = async (name, value) => {
        setForm((prevForm) => {
            const updatedForm = { ...prevForm, [name]: value };
            if (formError) {
                utils.checkFormError({ ...updatedForm }, fileSchema?.uploadFileSchema)
                    .then((validationResult) => {
                        setFormError(validationResult === true ? "" : validationResult);
                    });
            }
            return updatedForm;
        });
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const validTypes = [
                "text/csv",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            ];
            if (validTypes.includes(file.type)) {
                handleOnChange("file", file);
                setFormError({ ...formError, file: "" });
            } else {
                setFormError({ ...formError, file: "Please upload only CSV or XLSX files." });
            }
        }
    };

    const handleImportFile = async () => {
        const formData = new FormData();
        Object.keys(form).forEach((key) => {
            if (key === "file" && form[key]) {
                formData.append(key, form[key]);
            } else {
                formData.append(key, form[key]);
            }
        });

        const validationResult = await utils.checkFormError({ ...form }, fileSchema?.uploadFileSchema);

        if (validationResult == true) {
            setLoading(true);
            try {
                const res = await ioclFuelImport(formData);
                if (res?.responseCode == 200) {
                    setLoading(false);
                    toast?.success(res?.responseMessage);

                    setStatusCounts({
                        total: res?.data?.total || 0,
                        success: res?.data?.success || 0,
                        skipped_vehicle: res?.data?.skipped_vehicle || 0,
                        skipped_duplicate: res?.data?.skipped_duplicate || 0,
                    });

                    setSkippedVehicleList(res?.data?.skipped_vehicle_list || []);
                    setSkippedDuplicateTxn(res?.data?.skipped_duplicate_txn || []);
                    setSuccessVehicleList(res?.data?.success_vehicle_list || []);
                    setShowStatus(true);

                    // Auto select tab with data
                    if ((res?.data?.success_vehicle_list || []).length > 0) {
                        setActiveTab("success");
                    } else if ((res?.data?.skipped_vehicle_list || []).length > 0) {
                        setActiveTab("skipped_vehicle");
                    } else if ((res?.data?.skipped_duplicate_txn || []).length > 0) {
                        setActiveTab("skipped_duplicate");
                    }
                } else {
                    setLoading(false);
                }
            } catch (error) {
                setLoading(false);
                toast.error(error);
            }
        } else {
            setFormError(validationResult);
        }
    };

    // Excel table data for success
    const successTableData = successVehicleList.map((item, index) => ({
        "#": index + 1,
        "Vehicle No": item?.vehicleNo || "-",
    }));

    // Excel table data for skipped vehicle
    const skippedVehicleTableData = skippedVehicleList.map((item, index) => ({
        "#": index + 1,
        "Vehicle No": item?.vehicleNo || "-",
    }));

    // Excel table data for skipped duplicate
    const skippedDuplicateTableData = skippedDuplicateTxn.map((item, index) => ({
        "#": index + 1,
        "Vehicle No": item?.vehicleNo || "-",
        "Txn ID": item?.txnId || "-",
    }));

    return (
        <>
            <Heading title="IOCL Fuel Upload" download="iocl_fuel" />

            <div className="_Qwk_inr">
                <div className="_exceluploadBx">
                    <CommonInput
                        type="file"
                        onChange={handleFileChange}
                        accept=".csv, .xlsx"
                        error={formError?.file}
                    />
                </div>
                <ButtonExcelForQuick name="Fuel_Card" />
                <button
                    className="_flUpload_btn"
                    disabled={loading}
                    onClick={() => handleImportFile()}
                >
                    {loading ? "Uploading.." : "Upload File"}
                </button>
            </div>

            {/* ── Status Count Cards ── */}
            {showStatus && (
                <div className="tbdFilts_bx">
                    <div className="_hedFilts">
                        <h4>Status</h4>
                    </div>

                    <div className="_tbdOx_bx">
                        <div className="_fourTbx">
                            <h4>{statusCounts?.total}</h4>
                            <p className="__successTxt">Total</p>
                        </div>
                        <div className="_fourTbx">
                            <h4>{statusCounts?.success}</h4>
                            <p className="__successTxt">Success</p>
                        </div>
                        <div className="_fourTbx" style={{ cursor: "pointer" }} onClick={() => setActiveTab("skipped_vehicle")}>
                            <h4>{statusCounts?.skipped_vehicle}</h4>
                            <p className="__rejectTxe">Skipped Vehicle</p>
                        </div>
                        <div className="_fourTbx" style={{ cursor: "pointer" }} onClick={() => setActiveTab("skipped_duplicate")}>
                            <h4>{statusCounts?.skipped_duplicate}</h4>
                            <p className="__rejectTxe">Skipped Duplicate</p>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Tab + Table ── */}
            {showStatus && (skippedVehicleList?.length > 0 || skippedDuplicateTxn?.length > 0 || successVehicleList?.length > 0) && (
                <div className="_qwkTable_dix">

                    {/* Tab Buttons */}
                    <div className="_hedFilts" style={{ gap: "10px", marginBottom: "0" ,paddingLeft:30 }}>

                        {successVehicleList?.length > 0 && (
                            <button
                                onClick={() => setActiveTab("success")}
                                disabled={activeTab === "success"}
                                className="_flUpload_btn"
                                style={{
                                    opacity: activeTab === "success" ? 1 : 0.45,
                                    fontSize:14
                                }}
                            >
                                Success 
                            </button>
                        )}

                        {skippedVehicleList?.length > 0 && (
                            <button
                                onClick={() => setActiveTab("skipped_vehicle")}
                                disabled={activeTab === "skipped_vehicle"}
                                className="_flUpload_btn"
                                style={{
                                    opacity: activeTab === "skipped_vehicle" ? 1 : 0.45,
                                    fontSize:14
                                }}
                            >
                                Skipped Vehicle 
                            </button>
                        )}

                        {skippedDuplicateTxn?.length > 0 && (
                            <button
                                onClick={() => setActiveTab("skipped_duplicate")}
                                disabled={activeTab === "skipped_duplicate"}
                                className="_flUpload_btn"
                                style={{
                                    opacity: activeTab === "skipped_duplicate" ? 1 : 0.45,
                                    fontSize:14
                                }}
                            >
                                Skipped Duplicate 
                            </button>
                        )}

                        {/* Excel Download for active tab */}
                        <div style={{ marginLeft: "auto" ,paddingRight:30}}>
                            <ExcelDownload
                                tableData={
                                    activeTab === "success" ? successTableData :
                                    activeTab === "skipped_vehicle" ? skippedVehicleTableData :
                                    skippedDuplicateTableData
                                }
                            />
                        </div>
                    </div>

                    {/* ── Success Table ── */}
                    {activeTab === "success" && successVehicleList?.length > 0 && (
                        <div className="_indentTable _disPatchView _fuelCrd__table">
                            <table>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Vehicle No</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {successVehicleList?.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <div className="_dateNtime _pDate">
                                                    <p className="_tblText_inDent">{index + 1}</p>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="_dateNtime _pDate">
                                                    <p className="_tblText_inDent __successTxt">{item?.vehicleNo || "-"}</p>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {/* ── Skipped Vehicle Table ── */}
                    {activeTab === "skipped_vehicle" && skippedVehicleList?.length > 0 && (
                        <div className="_indentTable _disPatchView _fuelCrd__table">
                            <table>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Vehicle No</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {skippedVehicleList?.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <div className="_dateNtime _pDate">
                                                    <p className="_tblText_inDent">{index + 1}</p>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="_dateNtime _pDate">
                                                    <p className="_tblText_inDent __rejectTxe">{item?.vehicleNo || "-"}</p>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {/* ── Skipped Duplicate Table ── */}
                    {activeTab === "skipped_duplicate" && skippedDuplicateTxn?.length > 0 && (
                        <div className="_indentTable _disPatchView _fuelCrd__table">
                            <table>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Vehicle No</th>
                                        <th>Txn ID</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {skippedDuplicateTxn?.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <div className="_dateNtime _pDate">
                                                    <p className="_tblText_inDent">{index + 1}</p>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="_dateNtime _pDate">
                                                    <p className="_tblText_inDent __rejectTxe">{item?.vehicleNo || "-"}</p>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="_dateNtime _pDate">
                                                    <p className="_tblText_inDent">{item?.txnId || "-"}</p>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

export default IOCLFuelUpload;